import React from 'react';
import { Link } from 'react-router-dom';

import SubtleBadge from 'components/common/SubtleBadge';
import paths from 'routes/paths';
import { formatStatus } from 'utils/valueFormatters';
import { getGatePassBadgeColor } from './status';

export const getGatePassListColumns = (tenant, warehouse) => [
  {
    accessorKey: 'gate_pass_code',
    header: 'Code',
    cell: ({ row: { original } }) => {
      const { id, gate_pass_code } = original;
      return (
        <Link to={`/${tenant}/${warehouse}/gate-passes/${id}`}>
          <strong>{gate_pass_code}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'gate_pass_status',
    header: 'Status',
    cell: ({ row: { original } }) => {
      const { gate_pass_status } = original;
      return (
        <SubtleBadge pill bg={getGatePassBadgeColor(gate_pass_status)}>
          {formatStatus(gate_pass_status)}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'gate_pass_type',
    header: 'Type',
    cell: ({ row: { original } }) => formatStatus(original.gate_pass_type),
  },
  {
    accessorKey: 'to_party',
    header: 'To Party',
    cell: ({ row: { original } }) =>
      original.vendor?.name || original.target_warehouse?.name || '-',
  },
  {
    accessorKey: 'created_by',
    header: 'Created By',
    cell: ({ row: { original } }) => original.created_by.email,
  },
  {
    accessorKey: 'reason',
    header: 'Reason',
    cell: ({ row: { original } }) => original.reason || '-',
  },
  {
    accessorKey: 'reference_no',
    header: 'Reference No',
  },
];
